import { render } from "./ApprModal.vue?vue&type=template&id=121e5cd4&scoped=true"
import script from "./ApprModal.vue?vue&type=script&lang=js"
export * from "./ApprModal.vue?vue&type=script&lang=js"

import "./ApprModal.vue?vue&type=style&index=0&id=121e5cd4&lang=less&scoped=true"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121e5cd4"]])

export default __exports__